import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-demo-eleven',
  templateUrl: './home-demo-eleven.component.html',
  styleUrls: ['./home-demo-eleven.component.scss']
})
export class HomeDemoElevenComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
